import { atom } from 'jotai';

const cancellationReasonsFiltersAtom = atom({
  page: 1,
  sortKey: 'created_at',
  sortType: 'asc',
  searchText: '',
  date: new Date().toISOString(),
}, (get, set, update) => {
  set(cancellationReasonsFiltersAtom, update?.replace ? {
    ...update,
    replace: undefined,
  } : {
    ...get(cancellationReasonsFiltersAtom),
    page: update?.page ?? 1,
    ...update,
    newDate: null,
    date: update?.newDate !== undefined ? update.newDate : new Date().toISOString(),
  });
});

const cancellationReasonsInfoAtom = atom({
  cancellation_reasons: [],
  sort_fields: [],
  pages: null,
});

const gettingCancellationReasonsLoadingAtom = atom(false);
const savingCancellationReasonLoadingAtom = atom(false);
const deletingCancellationReasonLoadingAtom = atom(false);

export {
  cancellationReasonsFiltersAtom,
  cancellationReasonsInfoAtom,
  gettingCancellationReasonsLoadingAtom,
  savingCancellationReasonLoadingAtom,
  deletingCancellationReasonLoadingAtom,
};
